"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initHeader = initHeader;
const utils_1 = require("./utils");
function initHeader() {
    const header = (0, utils_1.qs)('.js-header');
    if (!(0, utils_1.guardElement)(header, 'Header not found'))
        return;
    const burger = (0, utils_1.qs)('.js-hamburger');
    const hdrNav = (0, utils_1.qs)('.header__nav');
    const hasCh = (0, utils_1.qsa)('.primary-menu>.menu-item-has-children');
    const mq = matchMedia('(min-width: 1080px)');
    if (!burger || !hdrNav)
        return;
    // Add arrows to menu items with children
    hasCh.forEach((item) => {
        const submenuArr = document.createElement('span');
        submenuArr.classList.add('arrow');
        item.appendChild(submenuArr);
    });
    // Burger menu toggle
    burger.addEventListener('click', () => {
        header.classList.toggle('open');
        document.documentElement.classList.toggle('open');
        hdrNav.style.transition = 'transform .3s ease-out';
        setTimeout(() => {
            hdrNav.style.transition = 'transform 0s';
        }, 500);
    });
    // Sticky header behavior
    let prevPosY = window.scrollY;
    const bPoint = innerHeight / 8;
    if (window.scrollY > bPoint) {
        header.classList.add('shy');
    }
    window.addEventListener('scroll', () => {
        const posY = window.scrollY;
        if (posY < bPoint) {
            header.classList.remove('shy');
        }
        else {
            header.classList.add('shy');
        }
        if (posY <= prevPosY || posY <= 0) {
            header.classList.remove('hide');
        }
        else {
            header.classList.add('hide');
        }
        prevPosY = posY;
    });
    // Submenu toggle
    const handleClick = (submenu) => {
        return () => {
            if (mq.matches)
                return;
            if (submenu.classList.contains('open')) {
                submenu.style.maxHeight = '0px';
                submenu.classList.remove('open');
            }
            else {
                submenu.classList.add('open');
                submenu.style.maxHeight = submenu.scrollHeight + 'px';
            }
        };
    };
    hasCh.forEach((hc) => {
        const submenu = hc.querySelector('.sub-menu');
        if (submenu) {
            hc.addEventListener('click', handleClick(submenu));
        }
    });
    // Reset submenus on desktop
    mq.addEventListener('change', (e) => {
        if (e.matches) {
            hasCh.forEach((item) => {
                const subMenu = item.querySelector('.sub-menu');
                if (subMenu) {
                    subMenu.classList.remove('open');
                    subMenu.style.maxHeight = '';
                }
            });
        }
    });
}
